<template>
    <div class="form-info">
        <div class="form-row">
            <div class="form-label">
                <label>商品名称</label>
            </div>
            <div class="form-value">
                <div class="value">{{title}}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>已配货数量</label>
            </div>
            <div class="form-value">
                <div class="value">{{allocQuantity}}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label>可调减数量</label>
            </div>
            <div class="form-value">
                <div class="value">{{maxQuantity}}</div>
            </div>
        </div>
        <div class="form-row">
            <div class="form-label">
                <label class="required">调减数量</label>
            </div>
            <div class="form-value width-1x">
                <el-input v-model="reduceQuantity" type="number" min="1"></el-input>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    export default {
        name: 'swb-order-goods-alloc-reduce',
        desc: '调减',
        props: ['title', 'quantity', 'maxQuantity'],
        data: function () {
            return {
                goodsTitle: null,
                allocQuantity: null,
                reduceQuantity: 1
            }
        },
        created: function () {
            this.goodsTitle = this.title;
            this.allocQuantity = this.quantity;
        },
        methods: {
            getDlgResult: function () {
                let result = {};
                let maxQuantity = this.maxQuantity;
                if(this.reduceQuantity > maxQuantity) {
                    result.type = 'warn';
                    result.message = '调减数量，不可超过可调减数量（' + maxQuantity + '）';
                    return result;
                }
                let allocQuantity = this.allocQuantity;
                if(this.reduceQuantity > allocQuantity) {
                    result.type = 'warn';
                    result.message = '调减数量，不可超过已配货数量（' + allocQuantity + '）';
                    return result;
                }
                let reduceQuantity = this.reduceQuantity;
                if(this.reduceQuantity <= 0) {
                    result.type = 'warn';
                    result.message = '调减数量不可为零或负数！';
                    return result;
                }
                result.type = 'info';
                result.reduceQuantity = reduceQuantity;
                return result;
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/compo/order/OrderGoodsAllocItemReduce.vue